module.exports = __webpack_public_path__ + "img/label_green.d215db5e.png";